var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVisionaiChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "comment-alt",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.919,
    height: 24.919,
    viewBox: "0 0 24.919 24.919",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_106076",
    "data-name": "Path 106076",
    d: "M20.766,0H4.153A4.153,4.153,0,0,0,0,4.153v12.46a4.153,4.153,0,0,0,4.153,4.153H7.164l4.621,3.907a1.038,1.038,0,0,0,1.341,0l4.628-3.907h3.011a4.153,4.153,0,0,0,4.153-4.153V4.153A4.153,4.153,0,0,0,20.766,0Zm2.077,16.613a2.077,2.077,0,0,1-2.077,2.077H17.755a2.077,2.077,0,0,0-1.34.491l-3.955,3.34-3.953-3.34h0a2.077,2.077,0,0,0-1.343-.491H4.153a2.077,2.077,0,0,1-2.077-2.077V4.153A2.077,2.077,0,0,1,4.153,2.077H20.766a2.077,2.077,0,0,1,2.077,2.077Z",
    transform: "translate(0 0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106077",
    "data-name": "Path 106077",
    d: "M7.038,7.077H12.23A1.038,1.038,0,1,0,12.23,5H7.038a1.038,1.038,0,0,0,0,2.077Z",
    transform: "translate(0.23 0.192)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106078",
    "data-name": "Path 106078",
    d: "M17.421,9H7.038a1.038,1.038,0,1,0,0,2.077H17.421a1.038,1.038,0,1,0,0-2.077Z",
    transform: "translate(0.23 0.345)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_106079",
    "data-name": "Path 106079",
    d: "M17.421,13H7.038a1.038,1.038,0,0,0,0,2.077H17.421a1.038,1.038,0,0,0,0-2.077Z",
    transform: "translate(0.23 0.498)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisionaiChat);
export default __webpack_public_path__ + "static/media/visionai_chat.3a3c8b560a4deb3363bf3fd41825ade8.svg";
export { ForwardRef as ReactComponent };